<script lang="ts">
  import {
    Avatar,
    AvatarFallback,
    AvatarImage
  } from '@gat-ship/vue-components/avatar'
  import { cn, useAppLoading } from '@gat-ship/vue-components'
  import { type IconValues } from '@gat-ship/icons'
  import { type HTMLAttributes } from 'vue'
  import { IconLoading } from '@gat-ship/vue-components'

  export interface AvatarIconProps {
    class?: HTMLAttributes['class']
    src?: string
    icon?: IconValues
    fallback?: string
    loadingId?: string
  }
</script>
<script setup lang="ts">
  const props = defineProps<AvatarIconProps>()

  const { isLoading } = useAppLoading()
</script>

<template>
  <div
    :class="
      cn(
        'text-md relative flex size-10 shrink-0 select-none items-center justify-center rounded-full bg-neutral-200 text-center uppercase text-neutral-950 dark:bg-neutral-700 dark:text-neutral-50',
        props.class
      )
    "
  >
    <avatar>
      <icon-loading
        class="absolute left-1/2 top-1/2 size-5 -translate-x-1/2 -translate-y-1/2 text-white"
        v-if="isLoading(loadingId)"
        :id="loadingId"
        chase
      />
      <avatar-image v-if="src" :src="src" />
      <gat-icon
        v-else-if="icon"
        :icon="icon"
        class="text-soft size-5 dark:text-neutral-400"
      />
      <avatar-fallback v-else>
        {{ fallback }}
      </avatar-fallback>
    </avatar>
  </div>
</template>
